var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgStrikethrough = function SvgStrikethrough(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 13h16",
    className: "icon-stroke-width"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.336 16c.56 0 1.021.464.911 1.012-.532 2.659-2.991 4.281-6.618 4.281-3.418 0-5.761-1.477-6.445-3.528a2.852 2.852 0 0 1-.146-.854c0-.794.488-1.307 1.233-1.307.622 0 1.025.281 1.293.94.55 1.648 2.149 2.417 4.188 2.417 2.233 0 3.832-1.147 3.832-2.722 0-.129.101-.239.23-.239h1.522ZM17.994 14h-4.083c-.439-.192-.972-.356-1.61-.495l-1.929-.403c-3.516-.745-5.115-2.38-5.115-4.92 0-3.015 2.65-5.09 6.397-5.09 3.04 0 5.432 1.429 6.116 3.784.06.171.097.379.097.635 0 .708-.5 1.172-1.208 1.172-.66 0-1.062-.305-1.343-.94-.598-1.623-1.941-2.32-3.699-2.32-2.063 0-3.589 1.002-3.589 2.613 0 1.282.916 2.136 3.199 2.625l1.916.402c2.676.566 4.209 1.495 4.851 2.937Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStrikethrough);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;